<div class="_container">
  <img src="assets/img/page-not-found.png" alt="Page not found" />
  <div class="_title">Page not Found</div>
  <div class="_subtitle">
    The page you are looking for might have been removed had its name changed or
    is temporarily unavailable.
  </div>
  <button class="_action" [routerLink]="'/'">Go to Homepage</button>
</div>
